import { useTranslation } from "react-i18next";

import { useWorkspacesModel } from "@lib/logic";

import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { useOpenResult } from "../../shared/useOpenResult";
import { AreaCell } from "../AreaCell";

// The selected floor's areas. Once loaded they stay on screen while a refresh loads newer sensor data.
export const AreasOnFloor = () => {
  const { t } = useTranslation();
  const { isLoading, areas } = useWorkspacesModel();
  const openResult = useOpenResult();

  if (isLoading) return <HaNResultList.Loading />;
  if (areas.length === 0) return <HaNResultList.Empty text={t("hereAndNow:NoAreasAvailable")} />;

  return (
    <HaNResultList>
      {areas.map(area => (
        <HaNResultList.Item
          key={area.id}
          nodeId={area.id}
          onSelect={() => openResult("area", area)}>
          <AreaCell area={area} />
        </HaNResultList.Item>
      ))}
    </HaNResultList>
  );
};
